import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import "./discoverymanagement.scss";
import "../../../../styles/global.scss";

function ViewRecommendedServices(props: {
  onCancel: () => void;
  setFlag: any;
  flag: boolean | undefined;
  isModalOpen: boolean | undefined;
  title: string;
  buttonText: string;
  userType: string;
  partnerID?: string;
  subtitle: string;
  reqDetails: any;
}) {
  const reqDetails = props.reqDetails;
  const [regulatoryCompliance, setRegulatoryCompliance] = useState(false);
  const [importClearance, setImportClearance] = useState(false);
  const [warehousingAndStorage, setWarehousingAndStorage] = useState(false);
  const [ecomSetupMgmt, setEcomSetupMgmt] = useState(false);
  const [retailDistribution, setRetailDistribution] = useState(false);
  const [orderFullfilment, setOrderFullfilment] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const handleClose = () => {
    setWarehousingAndStorage(false);
    setOrderFullfilment(false);
    setEcomSetupMgmt(false);
    setMarketing(false);
    setRetailDistribution(false);
    setRegulatoryCompliance(false);
    setImportClearance(false);
    props.onCancel();
  };

  useEffect(() => {
    if (props.userType === "Admin" && props.isModalOpen) {
      console.log("reqDetails", reqDetails);
      reqDetails?.partner_services?.map((service: any) => {
        if (
          service.service_id === 1 &&
          service.recommendation_status === "Recommended"
        ) {
          setRegulatoryCompliance(true);
        }
        if (
          service.service_id === 2 &&
          service.recommendation_status === "Recommended"
        ) {
          setImportClearance(true);
        }
        if (
          service.service_id === 3 &&
          service.recommendation_status === "Recommended"
        ) {
          setWarehousingAndStorage(true);
        }
        if (
          service.service_id === 4 &&
          service.recommendation_status === "Recommended"
        ) {
          setEcomSetupMgmt(true);
        }
        if (
          service.service_id === 5 &&
          service.recommendation_status === "Recommended"
        ) {
          setRetailDistribution(true);
        }
        if (
          service.service_id === 6 &&
          service.recommendation_status === "Recommended"
        ) {
          setOrderFullfilment(true);
        }
        if (
          service.service_id === 7 &&
          service.recommendation_status === "Recommended"
        ) {
          setMarketing(true);
        }
        return true;
      });
    }
  }, [reqDetails, props.userType, props.isModalOpen]);

  return (
    <Modal
      show={props.isModalOpen}
      onHide={handleClose}
      size="lg"
      className="brandpartnerapproval"
    >
      <Modal.Header closeButton>
        <Modal.Title className="font18-medium gray-800">
          Recommendation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="subtitle-row">
          <Col>
            <div className="font14-regular gray-500">
              The partner has been recommended for :
            </div>
          </Col>
        </Row>
        <ul className="services-list-container">
          {regulatoryCompliance &&
            props.reqDetails?.servicerequestIds?.includes(1) && (
              <li>Regulatory Compliance</li>
            )}
          {importClearance &&
            props.reqDetails?.servicerequestIds?.includes(2) && (
              <li>Importation And Clearance</li>
            )}
          {warehousingAndStorage &&
            props.reqDetails?.servicerequestIds?.includes(3) && (
              <li>Warehousing And Storage</li>
            )}
          {ecomSetupMgmt &&
            props.reqDetails?.servicerequestIds?.includes(4) && (
              <li>Ecommerce Setup And Management</li>
            )}
          {retailDistribution &&
            props.reqDetails?.servicerequestIds?.includes(5) && (
              <li>Retail Distribution</li>
            )}
          {orderFullfilment &&
            props.reqDetails?.servicerequestIds?.includes(6) && (
              <li>Order Fulfillment</li>
            )}
          {marketing && props.reqDetails?.servicerequestIds?.includes(7) && (
            <li>Marketing</li>
          )}
        </ul>
      </Modal.Body>
    </Modal>
  );
}

export default ViewRecommendedServices;
